import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface DisclaimerBannerProps {
  style?: React.CSSProperties;
}

const DisclaimerBanner: React.FC<DisclaimerBannerProps> = ({ style }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        padding: '10px 14px',
        background: '#fffbe6',
        border: '1.5px solid #faad14',
        borderRadius: '8px',
        marginBottom: 4,
        ...style,
      }}
    >
      <ExclamationCircleOutlined
        style={{ fontSize: '18px', color: '#faad14', marginTop: '1px', flexShrink: 0 }}
      />
      <div>
        <strong
          style={{ fontSize: '14px', lineHeight: '1.4', display: 'block', marginBottom: '2px' }}
        >
          重要提醒
        </strong>
        <div style={{ fontSize: '13px', lineHeight: '1.5', color: '#666' }}>
          AI 審閱結果及意見可能存在錯誤，僅供參考，如有任何疑慮，正式發布前請務必諮詢貴公司法務。
        </div>
      </div>
    </div>
  );
};

export default DisclaimerBanner;
